<template>
  <with-actions>
    <div class="row">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'carrier_type' | t | titlecase }}</h6>
      </div>
      <div class="col-md-8">
        <div class="card mb-5">
          <div class="card-body">
            <div>
              <div class="form-group" v-if="!carrier_type.id">
                <label>{{ 'carrier_concept_id' | t }}</label>
                <div class="row">
                  <div class="col-md-10">
                    <input class="form-control" type="number" v-model="carrier_library_concept_id" />
                  </div>
                  <div class="col-md-2">
                    <button class="btn btn-primary" @click="load_carrier_type_from_carrier_library()">
                      {{ 'load_from_carrier_library' | t }}
                    </button>
                  </div>
                </div>
                <small>{{ 'carrier_concept_id_description' | t }}</small>
                <hr />
              </div>
              <div class="form-group">
                <label>{{ 'name' | t }}</label>
                <input class="form-control" v-model="carrier_type.name" />
              </div>
              <div class="form-group">
                <label>{{ 'carrier_code' | t }}</label>
                <input class="form-control" v-model="carrier_type.carrier_code" />
              </div>
              <div class="form-group">
                <label>{{ 'carrier_group_id' | t }}</label>
                <div class="row">
                  <div class="col">
                    <small>{{ 'carrier_group_id_description' | t }}</small>
                  </div>
                </div>
                <input class="form-control" v-model="carrier_type.carrier_group_id" />
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6">
                    <p>
                      <label>{{ 'list_logo' | t }}</label>
                    </p>
                    <img :src="carrier_type.list_logo" width="200" v-if="carrier_type.list_logo" />
                    <input type="file" v-on:change="listLogoChange" />
                  </div>
                  <div class="col-md-6">
                    <p>
                      <label>{{ 'fulfillment_logo' | t }}</label>
                    </p>
                    <img :src="carrier_type.fulfillment_logo" width="200" v-if="carrier_type.fulfillment_logo" />
                    <input type="file" v-on:change="fulfillmentLogoChange" />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>{{ 'specification_version' | t }}</label>
                <input class="form-control" v-model="carrier_type.specification_version" />
              </div>
              <div class="form-group">
                <label>{{ 'description' | t }}</label>
                <textarea class="form-control" v-model="carrier_type.description"></textarea>
              </div>
              <div class="form-group">
                <label>{{ 'required_details' | t }}</label>
                <textarea class="form-control" v-model="carrier_type.required_details"></textarea>
              </div>
              <div class="form-group">
                <label>{{ 'onboarding_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.onboarding_url" />
              </div>
              <div class="form-group">
                <label>{{ 'export_document_email_to' | t }}</label>
                <input class="form-control" v-model="carrier_type.export_document_email_to" />
              </div>
              <div class="form-group">
                <label>{{ 'export_document_email_template' | t }}</label>
                <select class="form-control" v-model="carrier_type.export_document_email_template">
                  <option :value="null">none</option>
                  <option
                    v-for="tpl in mail_templates"
                    :value="tpl"
                    :selected="
                      tpl.id ==
                      (carrier_type.export_document_email_template
                        ? carrier_type.export_document_email_template.id
                        : null)
                    "
                  >
                    {{ tpl.name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>{{ 'price_parser_class' | t }}</label>
                <input class="form-control" v-model="carrier_type.price_parser_class" />
              </div>
              <div class="form-group">
                <label>{{ 'colli_type_support' | t }}</label>
                <select class="form-control" v-model="carrier_type.colli_type_support">
                  <option :value="null">none</option>
                  <option value="webshipper_provided">Webshipper defined</option>
                  <option value="carrier_provided">Carrier defined</option>
                  <option value="customer_provided">
                    Customer specific + carrier defined. This creates a local attr field where customers can provide a
                    comma separated list of colli types.
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>{{ 'convert_to_currency' | t }}</label>
                <input class="form-control" v-model="carrier_type.convert_to_currency" />
              </div>
              <div class="form-check">
                <input class="form-check-input" id="beta" type="checkbox" v-model="carrier_type.beta" />
                <label class="form-check-label" for="beta">Beta</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" id="supports_zpl" type="checkbox" v-model="carrier_type.supports_zpl" />
                <label class="form-check-label" for="supports_zpl">Supports ZPL</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  id="requires_approval"
                  type="checkbox"
                  v-model="carrier_type.requires_approval"
                />
                <label class="form-check-label" for="requires_approval">{{ 'requires_approval' | t }}</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  id="exclude_billing"
                  type="checkbox"
                  v-model="carrier_type.exclude_billing"
                />
                <label class="form-check-label" for="exclude_billing">{{ 'exclude_billing' | t }}</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  id="check_rotation"
                  type="checkbox"
                  v-model="carrier_type.check_rotation"
                />
                <label class="form-check-label" for="check_rotation">{{ 'check_rotation' | t }}</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  id="supports_documents"
                  type="checkbox"
                  v-model="carrier_type.supports_documents"
                />
                <label class="form-check-label" for="supports_documents">{{ 'supports_documents' | t }}</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  id="supports_customs"
                  type="checkbox"
                  v-model="carrier_type.supports_customs"
                />
                <label class="form-check-label" for="supports_customs">{{ 'supports_customs' | t }}</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  id="customer_specific_services"
                  type="checkbox"
                  v-model="carrier_type.customer_specific_services"
                />
                <label class="form-check-label" for="customer_specific_services">{{
                  'customer_specific_services' | t
                }}</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  id="supports_shipment_updates"
                  type="checkbox"
                  v-model="carrier_type.supports_shipment_updates"
                />
                <label class="form-check-label" for="supports_shipment_updates">{{
                  'supports_shipment_updates' | t
                }}</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  id="receive_custom_customs_document"
                  type="checkbox"
                  v-model="carrier_type.receive_custom_customs_document"
                />
                <label class="form-check-label" for="receive_custom_customs_document">{{
                  'receive_custom_customs_document' | t
                }}</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  id="show_send_time"
                  type="checkbox"
                  v-model="carrier_type.show_send_time"
                />
                <label class="form-check-label" for="show_send_time">{{ 'show_send_time' | t }}</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  id="show_send_time"
                  type="checkbox"
                  v-model="carrier_type.supports_shadow_bookings"
                />
                <label class="form-check-label" for="supports_shadow_bookings">{{
                  'supports_shadow_bookings' | t
                }}</label>
              </div>
              <div class="form-group" v-if="carrier_type.supports_shipment_updates">
                <label>{{ 'shipment_updates_limit' | t }}</label>
                <div style="margin-left: 20px">
                  <label for="shipment_updates_limit_minutes">{{ 'shipment_updates_limit_minutes' | t }}</label>
                  <input
                    class="col-md-5 form-control"
                    v-model.number="carrier_type.shipment_updates_limit_minutes"
                    type="number"
                  />
                </div>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="carrier_type.supports_test_mode" />
                <label class="form-check-label">{{ 'supports_test_mode' | t }}</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="carrier_type.requires_dutiable" />
                <label class="form-check-label">{{ 'requires_dutiable' | t }}</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="carrier_type.supports_price_quoting" />
                <label class="form-check-label">{{ 'supports_price_quoting' | t }}</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="carrier_type.rate_quote_validation" />
                <label class="form-check-label">{{ 'rate_quote_validation' | t }}</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="carrier_type.disable_prequote" />
                <label class="form-check-label">{{ 'disable_prequote' | t }}</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="carrier_type.hide" />
                <label class="form-check-label">{{ 'hide' | t }}</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="carrier_type.carrier_library_validation" />
                <label class="form-check-label">{{ 'carrier_library_validation' | t }}</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="carrier_type.is_edi" />
                <label class="form-check-label">{{ 'is_edi' | t }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'barcode_ordering' | t | titlecase }}</h6>
      </div>
      <div class="col-md-8">
        <div class="card mb-5">
          <div class="card-body">
            <div>
              <div class="form-group">
                <label>{{ 'barcode_mail' | t }}</label>
                <input class="form-control" v-model="carrier_type.barcode_mail" type="email" />
              </div>
              <div class="form-group">
                <label>{{ 'barcode_mail_template' | t }}</label>
                <select class="form-control" v-model="carrier_type.order_barcode_mail_template">
                  <option :value="null">none</option>
                  <option
                    v-for="tpl in mail_templates"
                    :value="tpl"
                    :selected="
                      tpl.id ==
                      (carrier_type.order_barcode_mail_template ? carrier_type.order_barcode_mail_template.id : null)
                    "
                  >
                    {{ tpl.name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>{{ 'barcode_customer_notification_mail_template' | t }}</label>
                <select class="form-control" v-model="carrier_type.barcode_customer_notification_mail_template">
                  <option :value="null">none</option>
                  <option
                    v-for="tpl in mail_templates"
                    :value="tpl"
                    :selected="
                      tpl.id ==
                      (carrier_type.barcode_customer_notification_mail_template
                        ? carrier_type.barcode_customer_notification_mail_template.id
                        : null)
                    "
                  >
                    {{ tpl.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'endpoints' | t | titlecase }}</h6>
      </div>
      <div class="col-md-8">
        <div class="card mb-5">
          <div class="card-body">
            <div>
              <div class="form-group">
                <label>{{ 'booking_endpoint_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.booking_endpoint_url" />
              </div>
              <div class="form-group">
                <label>{{ 'service_list_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.service_list_url" />
              </div>
              <div class="form-group">
                <label>{{ 'service_quote_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.service_quote_url" />
              </div>
              <div class="form-group">
                <label>{{ 'drop_point_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.drop_point_url" />
              </div>
              <div class="form-group">
                <label>{{ 'waybill_endpoint_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.waybill_endpoint_url" />
              </div>
              <div class="form-group">
                <label>{{ 'pickup_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.pickup_url" />
              </div>
              <div class="form-group">
                <label>{{ 'eod_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.eod_url" />
              </div>
              <div class="form-group">
                <label>{{ 'tracking_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.tracking_url" />
              </div>
              <div class="form-group">
                <label>{{ 'tracking_edi_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.tracking_edi_url" />
              </div>
              <div class="form-group">
                <label>{{ 'validation_endpoint_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.validation_endpoint_url" />
              </div>
              <div class="form-group">
                <label>{{ 'shipment_deletion_endpoint_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.shipment_deletion_endpoint_url" />
              </div>
              <div class="form-group">
                <label>{{ 'prebooking_endpoint_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.prebooking_endpoint_url" />
              </div>
              <div class="form-group">
                <label>{{ 'carrier_request_endpoint_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.carrier_request_endpoint_url" />
              </div>
              <div class="form-group">
                <label>{{ 'carrier_response_endpoint_url' | t }}</label>
                <input class="form-control" v-model="carrier_type.carrier_response_endpoint_url" />
              </div>
              <!-- <div class="form-group">
                <label>{{ "prebooking_endpoint_url" | t }}</label>
                <input
                  class="form-control"
                  v-model="carrier_type.carrier_response_url"
                />
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'local_attrs' | t | titlecase }}</h6>
      </div>
      <div class="col-md-8">
        <local-attrs v-model="carrier_type.local_attrs"></local-attrs>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'global_attrs' | t | titlecase }}</h6>
      </div>
      <div class="col-md-8">
        <global-attrs v-model="carrier_type.global_attrs"></global-attrs>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'filters' | t | titlecase }}</h6>
      </div>
      <div class="col-md-8">
        <address-validation-filters v-model="carrier_type.address_validation_filters"></address-validation-filters>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'validators' | t | titlecase }}</h6>
      </div>
      <div class="col-md-8">
        <address-validation-validators
          v-model="carrier_type.address_validation_validators"
        ></address-validation-validators>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-2 text-right">
        <h6 class="underline">Freightsolution</h6>
      </div>
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <div class="form-group">
              <label>Freightsolution name</label>
              <input class="form-control" v-model="carrier_type.freightsolution_name" />
            </div>
          </div>
          <datalist id="ws-services">
            <option :value="null">---</option>
            <option v-for="service in carrier_type.services" :value="service.service_code">
              {{ service.service_name }} ({{ service.service_code }})
            </option>
          </datalist>
          <div v-for="(mapping, idx) in carrier_type.freightsolution_service_mapping">
            <div class="row">
              <div class="col">
                <FreightsolutionMapping
                  v-model="carrier_type.freightsolution_service_mapping[idx]"
                  :services="carrier_type.services"
                  :freightsolutionServices="carrier_type.freightsolution_services"
                ></FreightsolutionMapping>
              </div>
              <div class="col-auto">
                <i class="fa fa-ban" @click="carrier_type.freightsolution_service_mapping.splice(idx, 1)"></i>
              </div>
            </div>
          </div>
          <button
            class="btn btn-outline-primary"
            @click="
              carrier_type.freightsolution_service_mapping.push({
                service_code: '',
                colli_type: '',
                freightsolution_service_name: ''
              })
            "
          >
            Add mapping
          </button>
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'cost_additions' | t | titlecase }}</h6>
      </div>
      <div class="col-md-8">
        <div class="card mb-2">
          <table class="table">
            <thead>
              <tr>
                <th>Service code</th>
                <th>Country code</th>
                <th>Zip</th>
                <th>Weight (g)</th>
                <th>Price</th>
                <th>Currency</th>
                <th>Type</th>
                <th>Note</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(line, idx) in carrier_type.cost_lines">
                <td>
                  <input class="form-control" v-model="line.service_code" />
                </td>
                <td>
                  <input class="form-control" v-model="line.country_code" size="2" />
                </td>
                <td>
                  <div class="row form-row">
                    <div class="col">
                      <input class="form-control" v-model="line.zip_from" />
                    </div>
                    <div class="col-auto">-</div>
                    <div class="col">
                      <input class="form-control" v-model="line.zip_to" />
                    </div>
                  </div>
                </td>
                <td>
                  <div class="row form-row">
                    <div class="col">
                      <input class="form-control" v-model="line.weight_from" />
                    </div>
                    <div class="col-auto">-</div>
                    <div class="col">
                      <input class="form-control" v-model="line.weight_to" />
                    </div>
                  </div>
                </td>
                <td>
                  <input class="form-control" v-model="line.price" size="5" />
                </td>
                <td>
                  <input class="form-control" v-model="line.currency" size="3" />
                </td>
                <td>
                  <select class="form-control" v-model="line.addition_type">
                    <option value="fixed">Fixed</option>
                    <option value="percent">Percent</option>
                  </select>
                </td>
                <td>
                  <input class="form-control" v-model="line.note" />
                </td>
                <td>
                  <i class="fa fa-ban text-danger" role="button" @click="carrier_type.cost_lines.splice(idx, 1)"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <button
          class="btn btn-primary"
          @click="
            carrier_type.cost_lines.push({
              service_code: '',
              country_code: '',
              zip_from: '',
              zip_to: '',
              weight_to: 0,
              weight_to: 0,
              price: 0,
              addition_type: 'fixed',
              note: ''
            })
          "
        >
          Add line
        </button>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'carrier_server_configuration' | t | titlecase }}</h6>
      </div>
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <div class="form-group">
              <label>{{ 'settings' | t | titlecase }}</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="carrier_type.require_ftp_configuration_id" />
                <label class="form-check-label">{{ 'require_ftp_configuration_id' | t }}</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="carrier_type.transmit_shipments" />
                <label class="form-check-label">{{ 'transmit_shipments' | t }}</label>
              </div>
            </div>
            <div class="form-group">
              <label>{{ 'service_configurations' | t | titlecase }}</label>
              <textarea class="form-control" v-model="formatted_service_translations"></textarea>
            </div>
            <div class="form-group">
              <label>{{ 'excluded_subcarriers' | t | titlecase }} (Comma separated ID's)</label>
              <textarea class="form-control" v-model="excludedSubcarriersString" @input="updateExcludedSubcarriers"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 text-right"></div>
      <div class="col-md-8">
        <button class="btn btn-success btn-lg" @click="save($event)" :disabled="!valid || !can('write_carrier_types')">
          {{ (carrier_type.id ? 'update_carrier_type' : 'create_carrier_type') | t }}
        </button>
      </div>
    </div>
  </with-actions>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import Api from '@/store/jsonapi';
import Alerts from '@/utils/alerts.js';
import moment from 'moment-es6';
import $ from 'jquery';
import FreightsolutionMapping from './freightsolution-mapping.vue';

export default {
  components: {
    FreightsolutionMapping
  },
  data: function () {
    return {
      errors: [],
      carrier_type: this.value,
      mail_templates: [],
      carrier_library_concept_id: null,
      excludedSubcarriersString: ''
    };
  },
  props: ['value'],
  computed: {
    formatted_service_translations: {
      get() {
        return JSON.stringify(this.carrier_type.service_translations, null, 2);
      },
      set(v, old) {
        try {
          const parsed_json = JSON.parse(v);

          this.carrier_type.service_translations = parsed_json;
        } catch (e) {
          Alerts.danger({ title: 'Invalid json' });
        }
        return v;
      }
    }
  },
  methods: {
    save: function (event) {
      $(event.target).loading();

      if (this.carrier_type && this.carrier_type.id) {
        Api.update('carrier_types', this.carrier_type)
          .then(({ data, errors, meta, links }) => {
            this.$router.push({ name: 'carrier_types' });
            $(event.target).loading(false);
          })
          .catch(({ errors }) => {
            $(event.target).loading(false);

            for (var i = 0; i < errors.length; i++) {
              Alerts.danger(errors[i]);
            }
          });
      } else {
        Api.create('carrier_types', this.carrier_type)
          .then(({ data, errors, meta, links }) => {
            this.$router.push({ name: 'carrier_types' });
            $(event.target).loading(false);
          })
          .catch(({ errors }) => {
            $(event.target).loading(false);

            for (var i = 0; i < errors.length; i++) {
              Alerts.danger(errors[i]);
            }
          });
      }
    },
    listLogoChange: function (e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createListLogo(files[0]);
    },
    createListLogo: function (file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        vm.carrier_type.list_logo = e.target.result;
      };
      reader.readAsDataURL(file);
      //  this.$emit('input', this.carrier_type.list_logo);
    },
    fulfillmentLogoChange: function (e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createFulfillmentLogo(files[0]);
    },
    createFulfillmentLogo: function (file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        vm.carrier_type.fulfillment_logo = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    valid: function () {
      return true;
    },
    load_carrier_type_from_carrier_library: async function () {
      const { data: carrier_type_details } = await Api.create('carrier_library_setups', {
        carrier_concept_id: this.carrier_library_concept_id
      });
      this.carrier_type = carrier_type_details;
      this.$set(this.carrier_type, 'local_attrs', carrier_type_details.local_attrs);
    },
    updateExcludedSubcarriers() {
      const subcarrierIds = this.excludedSubcarriersString.split(',').map(id => {
        const parsedId = parseInt(id.trim());
        return isNaN(parsedId) ? null : { subcarrier_id: parsedId };
      }).filter(sub => sub !== null);

      this.carrier_type.excluded_subcarriers = subcarrierIds;
     }
  },
  asyncComputed: {},
  mounted: async function () {
    let { data: tpls } = await Api.findAllPages('mail_templates');
    this.mail_templates = tpls;

    this.excludedSubcarriersString = this.carrier_type.excluded_subcarriers.map(sub => sub.subcarrier_id).join(',');
  }
};
</script>
